import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const pointageEntree = async (userId, image) => {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('image', image, 'photo.jpg');
  const res = await axios.post(
    `${API_URL}/pointage/entree`,
    formData,
    header({ 'Content-Type': 'multipart/form-data' })
  );
  return res.data;
};

export const pointageSortie = async (userId, image) => {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('image', image, 'photo.jpg');
  const res = await axios.post(
    `${API_URL}/pointage/sortie`,
    formData,
    header({ 'Content-Type': 'multipart/form-data' })
  );
  return res.data;
};

export const pointagePauseEntree = async (userId, pauseEntree) => {
  const res = await axios.post(
    `${API_URL}/pointage/pause/entree`,
    {
      userId,
      pauseEntree,
    },
    header({ 'Content-Type': 'application/json' })
  );
  return res.data;
};

export const pointagePauseSortie = async (userId, pauseSortie) => {
  const res = await axios.post(
    `${API_URL}/pointage/pause/sortie`,
    {
      userId,
      pauseSortie,
    },
    header({ 'Content-Type': 'application/json' })
  );
  return res.data;
};

export const getPointages = async (userId) => {
  const res = await axios.get(`${API_URL}/pointage/${userId}`, header());
  return res.data;
};

export const getAllPointages = async () => {
  const res = await axios.get(`${API_URL}/pointage`, header());
  return res.data;
};

export const getMonthlyPointageReport = async ({ month, userId } = {}) => {
  const params = new URLSearchParams();
  if (month) params.set('month', month);
  if (userId) params.set('userId', userId);
  const query = params.toString();
  const res = await axios.get(`${API_URL}/pointage/report/monthly${query ? `?${query}` : ''}`, header());
  return res.data;
};

const normalizePointagesResponse = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.response)) {
    return payload.response;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  return [];
};

const isSameDay = (dateA, dateB) =>
  dateA.getFullYear() === dateB.getFullYear() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getDate() === dateB.getDate();

export const getTodayEntryStatus = async (userId) => {
  if (!userId) {
    return { hasEntry: false, entry: null };
  }

  const payload = await getPointages(userId);
  const entries = normalizePointagesResponse(payload);

  const today = new Date();
  const todaysEntry = entries.find((entry) => {
    if (!entry?.entree) {
      return false;
    }

    const entryDate = new Date(entry.entree);
    return !Number.isNaN(entryDate.getTime()) && isSameDay(entryDate, today);
  });

  return {
    hasEntry: Boolean(todaysEntry),
    entry: todaysEntry ?? null,
  };
};

export const getPointageImage = async (imageName) => {
  const res = await axios.get(
    `${API_URL}/public/${imageName}`,
    { ...header(), responseType: 'blob' }
  );
  return res.data;
};

export const pointageBulk = async (records) => {
  const res = await axios.post(
    `${API_URL}/pointage/bulk`,
    { records },
    header({ 'Content-Type': 'application/json' })
  );
  return res.data;
};

export default {
  pointageEntree,
  pointageSortie,
  pointagePauseEntree,
  pointagePauseSortie,
  getPointages,
  getAllPointages,
  getMonthlyPointageReport,
  getTodayEntryStatus,
  getPointageImage,
  pointageBulk,
};
